import { useContext } from "react";
import { CommonPropsContext } from "../contexts/CommonPropsContext";
import Order from "./Order";

const OrderIndex = () => {
  const { dbConnections, loadingContext } =
    useContext(CommonPropsContext);

  return (
    <>
      {!loadingContext ? (
        dbConnections.length > 0 ? (
          <Order connection_key={dbConnections[0]} />
        ) : null
      ) : (
        <div id="loader"></div>
      )}
    </>
  );
};

export default OrderIndex;
